export default __webpack_public_path__ + "static/media/phoneImg.841b9893.png";